import PropTypes from 'prop-types';
import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
import auth from '../auth';
import { red500 } from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import { Link } from 'react-router';
import config from 'cfg';
import ContentSave from 'material-ui/svg-icons/content/save';
import Promise from 'bluebird';

class I18 extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            spec: {},
            values: {}
        };

        this.loadData();
    }

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    static defaultProps = {
        supportedLanguages: ['en', 'da', 'no']
    };

    loadData = () => {
        var user = this.context.user;
        let { supportedLanguages } = this.props;
        if (!user || !user.client) return null;

        return Promise.props({
            spec: fetch(`${config.dash.api.host}/api/widgets/spec?i18=true&access_token=${auth.getAccessToken()}`).then(response => response.json()),
            i18: fetch(`/api/i18/${user.client}/${user.username}`).then(response => response.json())
        }).then(result => {
            var values = result.i18.values || {};

            // if new values will came -> set those vals
            _.each(result.spec.widgets, widget => {
                values[widget.id] = values[widget.id] || {};
                _.each(supportedLanguages, lang => {
                    values[widget.id][lang] = values[widget.id][lang] || {};
                    var userLangDict = _.get(values, `${widget.id}.${lang}`, {});
                    var defLangDict = _.get(widget, `i18.${lang}`, {});

                    _.each(Object.keys(defLangDict), key => {
                        if (!userLangDict[key]) {
                            userLangDict[key] = defLangDict[key];
                        }
                    });
                });
            });

            this.setState({
                spec: result.spec,
                values: values
            });
        });
    };
    renderInputGroup = (widget, key, defVal) => {
        let { supportedLanguages } = this.props;
        let { values } = this.state;

        return (
            <rmd.TableRow key={widget.name + '_' + key}>
                <rmd.TableRowColumn>{`${widget.id}.lang.${key}`}</rmd.TableRowColumn>
                <rmd.TableRowColumn>{defVal}</rmd.TableRowColumn>
                {supportedLanguages.map(lang => {
                    var langDictionary = _.get(values, `${widget.id}.${lang}`, {});
                    var value = langDictionary[key];

                    return (
                        <rmd.TableRowColumn key={`${widget.id}.${lang}.${key}`}>
                            <rmd.TextField
                                defaultValue={value}
                                id={`${widget.id}.${lang}.${key}`}
                                onBlur={event => {
                                    var langVals = _.get(values, `${widget.id}.${lang}`, {});
                                    langVals[key] = event.target.value;
                                    _.set(values, `${widget.id}.${lang}`, langVals);
                                    this.setState({ values });
                                }}
                            />
                        </rmd.TableRowColumn>
                    );
                })}
            </rmd.TableRow>
        );
    };
    handleSaveTranslations() {
        var user = this.context.user;
        fetch(`/api/i18/${user.client}/${user.username}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.values)
        }).then(response => {
            let { status } = response;
            if (status == 200) {
                return response.json();
            }
        });
    }
    render() {
        let { supportedLanguages } = this.props;
        var user = this.context.user;
        var { spec, specError, filter } = this.state;

        if (!spec) {
            var iconStyle = {
                width: 30,
                height: 30,
                marginRight: 15,
                marginBottom: -10
            };

            return (
                <div>
                    <ErrorIcon color={red500} style={iconStyle} />
                    Widget specification not found for client {user.client}
                </div>
            );
        }

        return (
            <div className="pick-widget">
                <rmd.FloatingActionButton
                    onClick={() => this.handleSaveTranslations()}
                    style={{
                        position: 'fixed',
                        bottom: '30px',
                        right: '30px',
                        zIndex: 1000
                    }}
                >
                    <ContentSave />
                </rmd.FloatingActionButton>
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            {_.chain(spec.widgets || [])
                                .map((widget, i) => {
                                    var inherited = _.get(widget, 'i18.inherited', false);
                                    var dictionary = _.get(widget, 'i18.en', {});

                                    return (
                                        <div key={widget.id} className="col-xs-12">
                                            <rmd.Card className="widget-template">
                                                <div style={{ height: '1px' }} />
                                                <rmd.CardTitle title={widget.name} subtitle={`id: ${widget.id}`} />

                                                <rmd.CardText>
                                                    {_.get(widget, 'i18.inherited', false) && <div>I18 is inherited from parent widget</div>}
                                                    {!inherited && _.isEmpty(dictionary) && <div>I18 is not configured - ask developer</div>}
                                                    {!inherited &&
                                                        !_.isEmpty(dictionary) &&
                                                        <rmd.Table selectable={false}>
                                                            <rmd.TableHeader displaySelectAll={false}>
                                                                <rmd.TableRow>
                                                                    <rmd.TableHeaderColumn>Key</rmd.TableHeaderColumn>
                                                                    <rmd.TableHeaderColumn>Dev example</rmd.TableHeaderColumn>
                                                                    {supportedLanguages.map(lang => {
                                                                        return <rmd.TableHeaderColumn key={lang}>{lang}</rmd.TableHeaderColumn>;
                                                                    })}
                                                                </rmd.TableRow>
                                                            </rmd.TableHeader>
                                                            <rmd.TableBody displayRowCheckbox={false} showRowHover={true}>
                                                                {Object.keys(dictionary).map(k => this.renderInputGroup(widget, k, dictionary[k]))}
                                                            </rmd.TableBody>
                                                        </rmd.Table>}
                                                </rmd.CardText>
                                            </rmd.Card>
                                        </div>
                                    );
                                })
                                .value()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default I18;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/I18.js
 **/